








































































































































































































































































import Vue from 'vue'
import Component from 'vue-class-component'
import { PaymentsModule } from '@/store/modules/payments.module'
import { getModule } from 'vuex-module-decorators'
import Icon from '@/components/Icon.vue'
import DateTimeLabel from '@/components/labels/DateTimeLabel.vue'
import Card from '@/components/Card.vue'
import Api from '@/api'
import Avatar from '@/components/Avatar.vue'
import Table from '@/components/tables/Table.vue'
import PaymentDepositsSubrow from '@/views/app/management/payments/components/PaymentDepositsSubrow.vue'
import { ITableConfig } from '@/interfaces'
import {
  EPccDepositError,
  IGetPccDepositListDto,
  IPccDeposit,
  EPaymentsDepositStatus,
  AMERICA_TIMEZONE,
} from '@zunta/configurations'
import { getTooltipListText } from '@/utils/helpers'
import Confirm from '@/components/Confirm.vue'
import ModalV2 from '@/components/modals/ModalV2.vue'
import { FacilityModule } from '@/store/modules/facility.module'
import { Debounce } from 'vue-debounce-decorator'
import { UserModule } from '@/store/modules/user.module'
import { User } from '@/classes/User'
import {
  POSTED_DEPOSITS_COLUMNS,
  PROCESSING_DEPOSITS_COLUMNS,
} from '@/views/app/admin/pages/pcc-deposits/helpers/pccDeposits'
import DateInput2 from '@/components/inputs/DateInput2.vue'
import { formatInTimeZone } from 'date-fns-tz'
import AssignPccUserDeposits from '@/views/app/admin/pages/pcc-deposits/components/AssignPccUserDeposits.vue'

@Component({
  components: {
    ModalV2,
    PaymentDepositsSubrow,
    Table,
    Card,
    DateTimeLabel,
    Icon,
    Confirm,
    Avatar,
    DateInput2,
    AssignPccUserDeposits,
  }
})
export default class PccDeposits extends Vue {
  paymentsModuleInstance: PaymentsModule = getModule(PaymentsModule, this.$store)
  facilityModuleInstance: FacilityModule = getModule(FacilityModule, this.$store)
  userModuleInstance: UserModule = getModule(UserModule, this.$store)
  user: User = Api.getUser() as User

  openedRow: any
  openedRowIndex = -1

  reloadTableKey = 1
  tooltipTextCopied: string | null = null
  tooltipCopyText = 'Click to Copy'
  depositToMarkAsPosted: any | null = null
  postDepositInProgress = false
  isPostedListShown = false
  isAssignPccUserDepositsShown = false
  postedListDate: string | null = null

  getTooltipListText = getTooltipListText

  filters: IGetPccDepositListDto = {
    skip: 0,
    limit: 20,
  }

  reloadFilters: IGetPccDepositListDto = {}

  config: ITableConfig = {
    clearFilterBtn: {
      wrapperClass: 'position-absolute',
      wrapperStyle: 'top: -1rem; right: -1.5rem;',
      class: 'rounded-bottom',
    },
    usePagination: true,
    useSubrow: true,
    fetchFunction: this.paymentsModuleInstance.loadPccDeposits,
    rowClick: this.openPayments,
    maxHeight: 'calc(100vh - 392px)',
    minHeight: '100px',
    columns: this.isPostedListShown ? POSTED_DEPOSITS_COLUMNS : PROCESSING_DEPOSITS_COLUMNS,
  }

  get depositsList () {
    return this.$store.state.payments.pccDeposits.deposits as IPccDeposit[]
  }

  get recordsTotal () {
    return this.$store.state.payments.pccDeposits.total
  }

  get depositLinesTotal () {
    return this.$store.state.payments.pccDeposits.depositPayerLines
  }

  get userList () {
    return this.$store.state.user.users
  }

  getUser (id: number) {
    return this.userList.find((user: any) => user.id === id)
  }

  get userId () {
    return this.user.data.id
  }

  depositErrors (errors: EPccDepositError[]): string[] {
    if (!errors || !errors.length) {
      return []
    }

    const messages: string[] = []
    errors.forEach(error => {
      if (error === EPccDepositError.DEPOSIT_TOTAL) { messages.push('Payment amounts in this deposit don\'t total full deposit amount') }
      if (error === EPccDepositError.PAYMENT_TOTAL) { messages.push('The total payment amount does not match the applied transactions and convenience fees for one of the payments') }
      if (error === EPccDepositError.RESERVES) { messages.push('This deposit includes reserves') }
    })

    const missingInfoErrors = errors.filter(e => e.substring(0, e.indexOf('_')) === 'MISSING')
    if (missingInfoErrors && missingInfoErrors.length) {
      const missingInfo = missingInfoErrors.map(e => e.substring(e.indexOf('_') + 1).replace('_', ' ').toLowerCase())
      messages.push(`One or more payments in this deposit is missing information: ${missingInfo.join(', ')}`)
    }

    if (!messages.length) {
      messages.push('There are issues with the payments in this deposit.')
    }

    return messages
  }

  togglePostedList () {
    this.isPostedListShown = !this.isPostedListShown
    this.paymentsModuleInstance.resetPccDeposits()
    if (this.isPostedListShown) {
      this.postedListDate = formatInTimeZone(new Date(), AMERICA_TIMEZONE, 'MM/dd/yyyy')
      this.filters.manuallyMarkedAsPostedAt = this.postedListDate
      this.filters.status = EPaymentsDepositStatus.SYNCED
    } else {
      delete this.filters.manuallyMarkedAsPostedAt
      delete this.filters.status
    }
    this.config.columns = this.isPostedListShown ? POSTED_DEPOSITS_COLUMNS : PROCESSING_DEPOSITS_COLUMNS
    this.reloadTable()
  }

  updatePostedListDate (value: string) {
    if (this.postedListDate === value) { return }
    this.postedListDate = value
    this.filters.manuallyMarkedAsPostedAt = this.postedListDate
    this.reloadTable()
  }

  copyText (text: string) {
    navigator.clipboard.writeText(text)
    this.tooltipCopyText = 'Link Copied'

    setTimeout(() => {
      this.tooltipCopyText = 'Click to Copy'
    }, 500)
  }

  openPayments (deposit: any, index: any) {
    if (index === this.openedRowIndex) {
      this.openedRowIndex = -1
      this.openedRow = null
      return
    }

    this.openedRowIndex = index
    this.openedRow = deposit
  }

  closePayments () {
    this.openedRowIndex = -1
    this.openedRow = null
  }

  downloadDepositExportFile (depositId: number) {
    this.paymentsModuleInstance.downloadDepositForExport(depositId)
  }

  downloadDepositReport (deposit: IPccDeposit) {
    this.paymentsModuleInstance.downloadDepositReport({ depositId: deposit.id, fileName: `BatchReport_${deposit.willowId}.html` })
  }

  async assignUserToPccDeposits (deposits: IPccDeposit[]) {
    if (this.isPostedListShown) { return }
    deposits.forEach(deposit => { this.$set(deposit, 'loading', true) })
    await this.paymentsModuleInstance.assignUserToPccDeposits(deposits.map(d => d.id))
  }

  async created () {
    this.userModuleInstance.getAdminUsersList({})
    this.$socketManager.subscribeToPccDepositUpdates()
    this.$eventBus.$on('notifyPccDepositUpdate', () => { !this.isPostedListShown && this.paymentsModuleInstance.loadPccDeposits(this.reloadFilters) })
  }

  reloadTable () {
    this.reloadTableKey++
  }

  afterDataReload (filters: IGetPccDepositListDto) {
    this.closePayments()
    this.reloadFilters = { ...filters }
  }

  async markDepositAsPosted () {
    if (!this.depositToMarkAsPosted || !this.depositToMarkAsPosted.willowId) {
      this.$eventBus.$emit('notify', {
        color: 'var(--status-error-color)',
        message: 'Deposit is not selected',
        header: `Error`,
        icon: 'warning'
      })
      this.depositToMarkAsPosted = null
      return
    }
    this.postDepositInProgress = true
    const response = await this.paymentsModuleInstance.markPCCDepositAsSync(this.depositToMarkAsPosted.willowId)
    if (response.status === 'Error') {
      this.$eventBus.$emit('notify', {
        color: 'var(--status-error-color)',
        message: response.error,
        header: `Error`,
        icon: 'warning'
      })
      this.depositToMarkAsPosted = null
      this.postDepositInProgress = false
      return
    }
    this.$eventBus.$emit('notify', {
      color: 'var(--status-success-color)',
      message: 'Deposit marked as posted',
      header: 'Success',
      icon: 'check'
    })
    this.postDepositInProgress = false
    this.depositToMarkAsPosted = null
    this.$eventBus.$emit('notifyPccDepositUpdate')
  }

  @Debounce(300)
  async getOTPCode (facility: IPccDeposit['facility']) {
    if (!facility.mfaSecret || !facility.username) {
      return
    }
    this.tooltipCopyText = 'Request in progress'
    const response = await this.facilityModuleInstance.getOTPCodeForUsername(facility.username)
    if (response.error) {
      this.$eventBus.$emit('notify', {
        color: 'var(--status-error-color)',
        header: `OTP Error`,
        message: response.message,
        icon: 'warning'
      })
    } else {
      navigator.clipboard.writeText(String(response))
      this.tooltipCopyText = 'Copied to Clipboard'
      setTimeout(() => {
        this.tooltipCopyText = 'Click to Copy'
      }, 500)
    }
  }
}
